import { DateTime } from "luxon";

export function moveEventBlockDate(events, oldDate, newDate, zone) {
  const days = DateTime.fromISO(newDate).diff(DateTime.fromISO(oldDate), 'days').days;
  if (!Number.isInteger(days)) throw new Error('Choose a valid date.');
  return events.map(event => {
    const move = iso => {
      const original = DateTime.fromISO(iso, {zone});
      const day = original.plus({days}).toISODate();
      const result = eventTimeToUTC(day, original.toFormat('HH:mm'), zone);
      if (!result) throw new Error('That time does not exist on this date. Choose a different time first.');
      return result;
    };
    return {...event, startUTC: move(event.startUTC), endUTC: move(event.endUTC)};
  });
}

export function calendarTimeOptions(value = '', includeMidnight = false) {
  const times = Array.from({length: 96}, (_, i) => `${String(Math.floor(i / 4)).padStart(2, '0')}:${String(i % 4 * 15).padStart(2, '0')}`);
  if (includeMidnight) times.push('24:00');
  if (value && !times.includes(value)) times.push(value);
  return times.sort();
}

export function eventDateInZone(iso, zone) {
  return DateTime.fromISO(iso, { zone }).toISODate() || "";
}

// Date inputs are calendar days, not UTC instants. Keep them in the viewing zone.
export function eventTimeToUTC(date, time, zone) {
  const day = typeof date === "string"
    ? date
    : DateTime.fromJSDate(date, { zone }).toISODate();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day || "") || !/^\d{2}:\d{2}$/.test(time || "")) return null;
  if (time === "24:00") {
    const midnight = DateTime.fromISO(day, {zone});
    return midnight.isValid ? midnight.plus({days: 1}).startOf('day').toUTC().toISO() : null;
  }
  const value = DateTime.fromISO(`${day}T${time}`, { zone });
  // Reject nonexistent local times during a daylight-saving transition.
  if (!value.isValid || value.toFormat("yyyy-MM-dd'T'HH:mm") !== `${day}T${time}`) return null;
  return value.toUTC().toISO();
}

export function replaceEditedEvent(events, original, replacement) {
  return [...events.filter(event => original.eventId
    ? event.eventId !== original.eventId
    : !(event.createdAt === original.createdAt && event.startUTC === original.startUTC && event.tag === original.tag)), replacement];
}
